module.exports = __webpack_public_path__ + "img/3 - 5 - 2.4aca31bb.jpg";